// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__DfmUs","savePackageButton":"ClientWallet_savePackageButton__1ZmLC"};